import * as React from 'react';
import {useIsDesktop} from '../../hooks/useIsDesktop';
import {AcceptorsFilterViewBaseProps} from './model';
import {AcceptorsFilterDesktop} from './views/desktop';
import {AcceptorsFilterMobile} from './views/mobile';
import {AcceptorsFilterVisuallyImpaired} from './views/visuallyImpaired';

interface Props extends AcceptorsFilterViewBaseProps {
  visuallyImpaired?: boolean;
}

export default ({visuallyImpaired, ...props}: Props) => {
  const isDesktop = useIsDesktop();

  if (visuallyImpaired) {
    return <AcceptorsFilterVisuallyImpaired {...props} />;
  } else {
    return isDesktop ? <AcceptorsFilterDesktop {...props} /> : <AcceptorsFilterMobile {...props} />;
  }
};
